import * as React from 'react';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';

import { contactIsMutedSelector } from '@/redux/app/selectors/contact';
import { toggleMuteContact } from '@/redux/app/actions/contact';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';

export interface MuteContactButtonProps {
  contactId: string;
}

export const ContactMuteButton = ({ contactId }: MuteContactButtonProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const isMuted = useSelector(_.partial(contactIsMutedSelector, contactId));

  const dispatch = useDispatch();
  const handlePress = useCallback(() => {
    dispatch(toggleMuteContact(subdomain, contactId));
  }, [contactId, subdomain]);

  return (
    <button
      type="button"
      className="btn-red force-bg space-right mute-contact ui-link"
      id={`toggle-mute-${contactId}`}
      onKeyPress={handlePress}
      onClick={handlePress}
    >
      {isMuted ? 'Unmute' : 'Mute'}
    </button>
  );
};
